import http from "../http";

const work = {
  // 获取我受理的工单
  getMyAcceptWorkList(filters) {
    return http.post(`/work_order/myDealWorkOrder/mylist`, filters);
  },
  // 受理工单详情
  getMyDealWorkOrderDetail(filters) {
    return http.get(`/work_order/myDealWorkOrder/getbyId`, { params: filters });
  },
  // 处理受理工单
  dealWorkOrderById(model) {
    return http.post(`/work_order/myDealWorkOrder/dealWorkOrderById`, model);
  },
  //获取首页信息
  getWorkIndexPagefilters(filters) {
    return http.get(`/work_order/workOrders/monitorData`, { params: filters });
  },
  // 获取我提交工单的列表
  getMySubmitWork(filters) {
    return http.post(`/work_order/workOrders/myworkorder`, filters);
  },
    // 获取我审批工单的列表
    getMyApproveWork(filters) {
      return http.post(`/work_order/workOrders/flow/myApprove`, filters);
    },
  getTreeList(filters) {
    //获取工单问题类型树形列表
    return http.get(`/work_order/workOrderTypes/treeList`, { params: filters });
  },
  // 删除工单
  delById(filters) {
    return http.post(`/work_order/workOrders/delbyid?id=${filters.id}`);
  },
  // 查看工单详情
  getWorkDetail(filters) {
    return http.get(`/work_order/workOrders/getbyid`, { params: filters });
  },
  // 创建工单
  createWork(filters) {
    return http.post(`/work_order/workOrders/addWorkOrder`, filters);
  },
  /** 获取用户档案（北森） */
  getUserArchive(params) {
    return http.get(`/work_order/userInfo/archive`, { params });
  },
  /** 按工作地点查询 HR */
  queryWorkLocationHr(params) {
    return http.get(`/work_order/work-location-hr/query`, { params });
  },
  /** 公司主体下拉 */
  getCompanyEntityDropdown(params) {
    return http.get(`/work_order/company-entity/dropdown`, { params });
  },
  /** 软件下拉（账号开通等） */
  getSoftwareDropdown() {
    return http.get(`/work_order/softwareInfo/dropdown`);
  },
  // 关闭工单
  closeWork(filters) {
    return http.post(`/work_order/workOrders/closebyid`, filters);
  },
  // 驳回状态修改
  rejectEdit(filters) {
    return http.post(`/work_order/workOrders/updateWorkOrder`, filters);
  },
  // 驳回状态修改
  dealWorkOrderByIdNew(filters) {
    return http.post(`/work_order/workOrders/dealWorkOrderById`, filters);
  },
  replyWorkOrder(filters) {
    return http.post(`/work_order/workOrders/reply`, filters);
  },
  // 我的干系工单列表
  myRelationOrder(filters) {
    return http.post(`/work_order/workOrders/myRelationOrder`, filters);
  },
  /**
   * 关联工单查询
   * @param filters
   * @returns {Promise<AxiosResponse<any>>}
   */
  getRelationWorkOrder(filters) {
    return http.get("/work_order/workOrders/selectRelationWorkOrder", {
      params: filters,
    });
  },
  //更新关联关注人
  editRelationUser(data) {
    return http.post("/work_order/workOrderSubInfo/editRelationUser", data);
  },
  //审核通过
  passRealtionWorkOrder(data) {
    return http.post("/work_order/workOrders/flow/passWorkOrder", data);
  },
  //审核不通过
  notPassRealtionWorkOrder(data) {
    return http.post("/work_order/workOrders/flow/notPassWorkOrder", data);
  },
  //驳回回显
  getWorkOrderShow(params) {
    return http.get("/work_order/workOrders/getRejectWorkOrderInfo", {
      params: params,
    });
  },
  //重新处理
  reDealWorkOrder(data) {
    return http.post("/work_order/workOrders/reprocess", data);
  },
  //处理完毕
  myDealWorkOrder(data) {
    return http.post("/work_order/myDealWorkOrder/dealWorkOrderById", data);
  },

  // 编辑相关机构
  editCompanyInfo(data) {
    return http.post(`/work_order/workOrderSubInfo/editCompanyInfo`, data);
  },
  // 编辑涉及金额
  editMoney(data) {
    return http.post(`/work_order/workOrderSubInfo/editMoney`, data);
  },
  // 编辑医生信息
  editDoctorInfo(data) {
    return http.post(`/work_order/workOrderSubInfo/editDoctorInfo`, data);
  },
  // 编辑关联项目信息
  editAccurateProjectInfo(data) {
    return http.post(
      `/work_order/workOrderSubInfo/editAccurateProjectInfo`,
      data,
    );
  },
  // 新增关联工单
  addWorkRelationId(data) {
    return http.post("/work_order/rwk/add", data);
  },
  // 删除关联工单
  deleteWorkRelationId(data) {
    return http.post("/work_order/rwk/delete", data);
  },
  // 获取关联工单
  getWorkRelationIds(wkOrderId) {
    return http.get(`/work_order/rwk/list/${wkOrderId}`);
  },
  currExtendParam(params) {
    return http.get("/work_order/userInfo/curr/extendParam", { params });
  },
  updateCurrExtendParam(params) {
    return http.get("/work_order/userInfo/curr/extendParam/update", { params });
  },
  // 导出我关注的工单列表
  exportMyRelationOrder(params) {
    return http.post("/work_order/workOrders/myRelationOrder/export", params,{
      responseType: "blob",
    });
  },
};
export default work;
